module.exports = __webpack_public_path__ + "static/media/graphic-design.bb9bce16.png";